import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ChatWidget from "./components/ChatWidget";
import ScrollToTop from "./components/ScrollToTop";
import InquiryModal from "./components/InquiryModal";
import Home from "./pages/Home";
import LandingPage from "./pages/LandingPage";
import ServicePage from "./pages/ServicePage";
import ServiceDetail from "./pages/ServiceDetail";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Resources from "./pages/Resources";
import Blogs from "./pages/Blogs";
import BlogDetail from "./pages/BlogDetail";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import ApplicationMain from "./pages/ApplicationMain";
import { Toaster } from "./components/ui/sonner";

// Layout wrapper to conditionally show navbar/footer
const Layout = ({ children, onOpenModal, isModalOpen, onCloseModal, modalContext }) => {
  const location = useLocation();
  const isLandingPage = location.pathname === '/lp';

  return (
    <>
      {!isLandingPage && <Navbar onOpenModal={onOpenModal} />}
      {children}
      {!isLandingPage && <Footer />}
      <ChatWidget />
      <Toaster />
      <InquiryModal 
        isOpen={isModalOpen} 
        onClose={onCloseModal}
        buttonContext={modalContext}
      />
    </>
  );
};

function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContext, setModalContext] = useState('');

  const handleOpenModal = (context) => {
    setModalContext(context);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setModalContext('');
  };

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Layout 
          onOpenModal={handleOpenModal}
          isModalOpen={isModalOpen}
          onCloseModal={handleCloseModal}
          modalContext={modalContext}
        >
          <Routes>
            <Route path="/" element={<Home onOpenModal={handleOpenModal} />} />
            <Route path="/lp" element={<LandingPage />} />
            <Route path="/about" element={<About />} />
            <Route path="/services/:serviceType" element={<ServicePage />} />
            <Route path="/services/:category/:serviceSlug" element={<ServiceDetail onOpenModal={handleOpenModal} />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/blogs/:id" element={<BlogDetail />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/application/main" element={<ApplicationMain />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
